import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// 创建一个新的 store 实例
const store = createStore({
  state() {
    return {
      user: null, // 用户信息
      token: null, // 认证令牌
      permissions: [], // 用户权限列表
    };
  },
  getters: {
    // 获取用户信息
    getUser(state) {
      return state.user;
    },
    // 获取认证令牌
    getToken(state) {
      return state.token;
    },
    // 获取用户权限
    getPermissions(state) {
      return state.permissions;
    }
  },
  mutations: {
    // 设置用户信息
    SET_USER(state, user) {
      state.user = user;
    },
    // 设置认证令牌
    SET_TOKEN(state, token) {
      state.token = token;
    },
    // 设置用户权限
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    // 清除用户信息
    CLEAR_USER(state) {
      state.user = null;
      state.token = null;
      state.permissions = [];
    }
  },
  actions: {
    // 登录操作
    login({ commit }, { userInfo, token }) {
      try {
                
        // 存储用户信息和令牌
        commit('SET_USER', userInfo);
        commit('SET_TOKEN', token);
        commit('SET_PERMISSIONS', []);
        
        return true;
      } catch (error) {
        commit('SET_ERROR', error.message || '登录失败');
        return false;
      } finally {
      }
    },
    // 登出操作
    logout({ commit }) {
      // 清除用户信息
      commit('CLEAR_USER');
      
      // 这里可以添加其他登出操作，如清除缓存、取消订阅等
    },
    // 更新用户信息
    updateUser({ commit }, userData) {
      commit('SET_USER', { ...this.state.user, ...userData });
    },
    // 加载用户信息（如刷新页面后）
    loadUser({ commit }) {
      // 由于使用了vuex-persistedstate，用户信息会自动从本地存储加载
      // 这里可以添加额外的逻辑，如验证令牌有效性等
    }
  },
  // 使用vuex-persistedstate插件实现数据持久化
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ['user', 'token', 'permissions']
    })
  ]
});

export default store;  